<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="w-full">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Kullanıcı" : "Kullanıcı Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <div id="pager" class="mt-3">
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <h3 class="mx-auto my-3">{{stepHeader}}</h3>
            </vs-col>
          </vs-row>

        </div>
        <form data-vv-scope="form-1" v-show="step == 1" @keyup.enter="goNextStep">
          <div class="px-6">
            <!-- User Image -->
            <template v-if="newUser.imageUrl">

              <!-- Image Container -->
              <div class="img-container w-full mx-auto flex items-center justify-center" style="max-width:120px;">
                <img v-if="!needUpload" :src="$baseUrl + '/' + newUser.imageUrl" alt="img" class="responsive">
                <img v-if="needUpload" :src="newUser.imageUrl" alt="img" class="responsive">
              </div>

              <!-- Image upload Buttons -->
              <div class="modify-img flex justify-between mt-5">
                <input :disabled="!$isCenterBranch()" type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Fotoğrafı Güncelle</vs-button>
                <vs-button type="flat" color="danger" @click="newUser.imageUrl = null;">
                  Fotoğrafı Sil
                </vs-button>
              </div>
            </template>

            <div class="upload-img" v-if="!newUser.imageUrl">
              <input :disabled="!isAddPermission" type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button v-if="isAddPermission" class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
                Fotoğraf Yükle</vs-button>
            </div>

            <vs-input :disabled="!isAddPermission" id="name" name="Ad" v-validate="'required|min:2|max:20'" v-model="newUser.name"
              class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Ad" />
            <span class="text-danger text-sm" v-show="errors.has('form-1.Ad')">{{ errors.first('form-1.Ad')}}</span>

            <vs-input :disabled="!isAddPermission" id="surname" name="Soyad" v-validate="'required|min:2|max:20'" v-model="newUser.surname"
              class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Soyad" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Soyad')">{{ errors.first('form-1.Soyad') }}</span>

            <vs-input :disabled="!isAddPermission" id="emailField" name="Email" v-validate="'email'" type="email" v-model="newUser.email"
              class="w-full" icon-pack="feather" icon="icon-mail" label-placeholder="Email" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Email')">{{ errors.first('form-1.Email') }}</span>

            <vs-input :disabled="!isAddPermission" id="phoneNumber" name="Telefon" v-mask="phoneMask" v-validate="'length:14'"
              v-model="newUser.phoneNumber" class="w-full" icon-pack="feather" icon="icon-phone"
              label-placeholder="Telefon" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Telefon')">{{ errors.first('form-1.Telefon') }}</span>

            <vs-input :disabled="!isAddPermission" id="tcNumber" name="TC" v-mask="tcMask" v-validate="'digits:11'" v-model="newUser.tcNumber"
              class="w-full" icon-pack="feather" icon="icon-pocket" label-placeholder="T.C Number" />
            <span class="text-danger text-sm" v-show="errors.has('form-1.TC')">{{ errors.first('form-1.TC') }}</span>

            <vs-input  :disabled="!isAddPermission" id="birthDate" name="Doğum Tarihi" v-validate="'date_format:dd/MM/yyyy'"
              v-model="normalizedBirthDate" v-mask="dateMask" class="w-full" icon-pack="feather" icon="icon-calendar"
              label-placeholder="Doğum Tarihi" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Doğum Tarihi')">{{ errors.first('form-1.Doğum Tarihi') }}</span>

          </div>
        </form>
        <form data-vv-scope="form-2" v-show="step == 2" @keyup.enter="submitData">
          <div class="px-6">
            <vs-input :disabled="!isAddPermission" id="userName" name="Kullanıcı Adı" v-validate="'required|userNamePolicy|min:3|max:20|checkUserName'"
              v-model="newUser.userName" class="w-full" icon-pack="feather" icon="icon-user-plus"
              label-placeholder="Kullanıcı Adı" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-2.Kullanıcı Adı')">{{ errors.first('form-2.Kullanıcı Adı') }}</span>

            <div class="w-full" v-if="!(newUser.id)">
              <vs-input :disabled="!isAddPermission" id="passwordField" name="Şifre" ref="passwordField"
                v-validate="'required|passwordPolicy|min:6|max:10'" type="password" v-model="newUser.password"
                class="w-full" icon-pack="feather" icon="icon-shield" label-placeholder="Şifre" />
              <span class="text-danger text-sm"
                v-show="errors.has('form-2.Şifre')">{{ errors.first('form-2.Şifre') }}</span>

              <vs-input id="rePassword" name="Şifre Tekrar" v-validate="'required|confirmed:passwordField'"
                type="password" v-model="rePassword" class="w-full" icon-pack="feather" icon="icon-shield"
                label-placeholder="Şifre Tekrar" />
              <span class="text-danger text-sm"
                v-show="errors.has('form-2.Şifre Tekrar')">{{ errors.first('form-2.Şifre Tekrar') }}</span>
            </div>

            <div class="w-full mt-4" v-else>
              <vx-tooltip color="primary" text="Şifreyi Sıfırla" v-if="!isPasswordUpdate" position="left">
                <vs-button :disabled="!isAddPermission" color="primary" icon-pack="feather" icon="icon-lock" @click="isPasswordUpdate = true" />
              </vx-tooltip>
              <vx-tooltip color="danger" text="Şifre Sıfırlamaktan Vazgeç" v-else  position="left">
                <vs-button color="danger" icon-pack="feather" icon="icon-x"
                  @click="newUser.password = null;newUser.rePassword = null;isPasswordUpdate = false;" />
              </vx-tooltip>
            </div>


            <div class="w-full" v-if="isPasswordUpdate">
              <vs-input id="passwordUField" name="Şifre Günc." ref="passwordField"
                v-validate="'required|passwordPolicy|min:6|max:10'" type="password" v-model="newUser.password"
                class="w-full" icon-pack="feather" icon="icon-shield" label-placeholder="Şifre" />
              <span class="text-danger text-sm"
                v-show="errors.has('form-2.Şifre Günc.')">{{ errors.first('form-2.Şifre Günc.') }}</span>

              <vs-input id="rePassword" name="Şifre Günc. Tekrar" v-validate="'required|confirmed:passwordField'"
                type="password" v-model="rePassword" class="w-full" icon-pack="feather" icon="icon-shield"
                label-placeholder="Şifre Tekrar" />
              <span class="text-danger text-sm"
                v-show="errors.has('form-2.Şifre Günc. Tekrar')">{{ errors.first('form-2.Şifre Günc. Tekrar') }}</span>
            </div>

            <v-select :disabled="branches.length == 0 || !isAddPermission" id="branch"  name="Şube" v-validate="'required'"
              v-model="newUser.branch" itemid="id" label="name" placeholder="Şube Seçimi.." :options="branches"
              class="mt-4" :clearable="true"></v-select>
            <span class="text-danger text-sm"
              v-show="errors.has('form-2.Şube')">{{ errors.first('form-2.Şube') }}</span>

            <v-select :disabled="roles.length == 0 || !isAddPermission" id="role" name="Rol" v-validate="'required'" v-model="newUser.role"
              itemid="id" label="name" placeholder="Rol Seçimi.." :options="roles" class="mt-4" :clearable="true"
              multiple></v-select>
            <span class="text-danger text-sm" v-show="errors.has('form-2.Rol')">{{ errors.first('form-2.Rol') }}</span>

            <vs-input :disabled="!isAddPermission" v-if="isAddPermission" id="PINcode" name="PIN" v-validate="{required: true,digits:4}" @input="validatePIN"
              v-show="isPINAcceptable" v-model="newUser.userCode" class="w-full" icon-pack="feather" icon="icon-shield"
              label-placeholder="Satış Ekranı Giriş Kodu" />
            <span class="text-danger text-sm" v-show="errors.has('form-2.PIN')">{{ errors.first('form-2.PIN')}}</span>
            <span class="text-danger text-sm"
              v-show="!isPinValidate && newUser.userCode != null && newUser.userCode.length == 4">{{ "Giriş Kodu Kullanımda."}}</span>
          </div>
        </form>
        <div class="flex mt-5 px-6">
          <vs-button v-show="step == 2" icon-pack="feather" icon="icon-arrow-left" class="mr-auto"
            @click="step = 1;stepHeader = 'Kişisel Bilgiler';">Geri</vs-button>
          <vs-button v-show="step ==1" class="mr-auto" type="gradient" color="danger"
            @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button v-show="step == 1" icon-pack="feather" icon="icon-arrow-right" class="ml-auto" icon-after
            @click="goNextStep">İleri</vs-button>
          <vs-button v-if="isAddPermission" v-show="step==2" class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import {
    checkNewUserName,
    getBranchNameList,
    getRoleList,
    createNewUser,
    updateUser,
    uploadImage,
    checkNewUserCode
  } from '@/api/User';
  export default {
    props: {
      isAddPermission: {
        type: Boolean,
        required: true
      },
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {

      return {
        isPasswordUpdate: false,
        isPinValidate: false,
        isPINAcceptable: false,
        needUpload: false,
        tcMask: "###########",
        phoneMask: "#### ### ## ##",
        dateMask: "##/##/####",
        newUser: {
          id: null,
          userName: "",
          email: "",
          phoneNumber: "",
          name: "",
          surname: "",
          imageUrl: "",
          birthDate: "",
          password: "",
          tcNumber: "",
          roleId: [],
        },
        normalizedBirthDate: "",
        step: 1,
        stepHeader: "Kişisel Bilgiler",
        rePassword: "",
        branches: [],
        roles: [],
        checkedUserName: false,
        userPhotoBinary: "",

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape() {
        if (this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      validatePIN: _.debounce(async function (e) {
        let id = this.newUser.id != null ? this.newUser.id : 0;
        await checkNewUserCode(this.newUser.userCode, id, this.newUser.branch.id).then(res => {
          this.isPinValidate = !res.data;
        });
      }, 200),
      uploadImage: async function () {
        let image = this.userPhotoBinary;
        let formData = new FormData();
        formData.append('image', image)
        await uploadImage(formData).then(res => {
          if (res.status == 200) {
            this.newUser.imageUrl = "StaticFiles/images/" + res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kullanıcı Fotoğrafı Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Sunucu Bağlantı Hatası',
            text: 'Kullanıcı Fotoğrafı Yüklenemedi !'
          });
        });
      },
      getBranchNameList: function () {
        getBranchNameList().then(res => {
          if (res && res.status === 200) this.branches = res.data
          else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Şube Listesi Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Sunucu Bağlantı Hatası',
            text: 'Şube Listesi Yüklenemedi !'
          });
        });
      },
      getRoleList: function () {
        getRoleList().then(res => {
          if (res && res.status === 200) this.roles = res.data.items
          else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Rol Listesi Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Sunucu Bağlantı Hatası',
            text: 'Rol Listesi Yüklenemedi !'
          });
        });
      },
      initValues() {
        this.isPasswordUpdate = false;
        this.needUpload = false;
        this.newUser = {
          id: null,
          userName: "",
          email: "",
          phoneNumber: "",
          name: "",
          surname: "",
          imageUrl: "",
          birthDate: null,
          password: "",
          tcNumber: "",
          roleId: [],
          branchId: null
        };
        this.normalizedBirthDate = "";
        this.step = 1;
        this.stepHeader = "Kişisel Bilgiler";
        this.rePassword = "";
        this.checkedUserName = false;
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-2');
        if (checker && this.isPinValidate) {
          (this.needUpload) ? await this.uploadImage(): null;
          await this.mapNewUser();
          if (this.newUser.id) {
            updateUser(this.newUser).then(res => {
              if (res && res.status === 200) {
                this.$store.dispatch("user/updateUser", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Kullanıcı Güncelleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata ! ' + res.status,
                  text: 'Kullanıcı Güncelleme İşlemi Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newUser.id = 0;
            createNewUser(this.newUser).then(res => {
              if (res && res.status === 200) {
                this.$store.dispatch("user/addUser", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Kullanıcı Ekleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Kullanıcı Ekleme İşlemi Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          }
        }
      },
      updateCurrImg(input) {
        this.needUpload = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.newUser.imageUrl = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
          this.userPhotoBinary = input.target.files[0];
        }
      },
      getCheckUserName: async function (newUserName) {
        let id = this.newUser.id == null ? 0 : this.newUser.id
        await checkNewUserName(newUserName, id).then(res => {
          this.checkedUserName = res.data;
        });
        return this.checkedUserName;
      },
      goNextStep: function () {

        this.$validator.validateAll('form-1').then(result => {
          if (result) {
            this.step = 2;
            this.stepHeader = 'Hesap Bilgileri';
          }
        });
      },
      mapNewUser: async function () {
        this.newUser.roleId = [];
        if (this.newUser.role[0].id) {
          await this.newUser.role.forEach(role => {
            this.newUser.roleId.push(role.id);
          });
        } else {
          this.newUser.roleId = this.newUser.role;
        }

        //delete this.newUser.role;
        this.newUser.branchId = this.newUser.branch.id;
        //delete this.newUser.branch;
        if (this.newUser.birthDate != null) {
          let parts = this.normalizedBirthDate.split("/");
          this.newUser.birthDate = parts[2] + "-" + parts[1] + "-" + parts[0];
        }
      }
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      'newUser.branch': {
        deep: true,
        handler(val) {
          if (val) {
            this.isPINAcceptable = true;
            this.validatePIN();
          } else this.isPINAcceptable = false;
        }
      },
      isSidebarActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newUser = _.cloneDeep(this.data); //Şurda.
          this.normalizedBirthDate = this.newUser.birthDate;
          this.needUpload = false;
          this.isPinValidate = true;
        }
      }
    },
    mounted: function () {
      this.getBranchNameList();
      this.getRoleList(); 
    },
    created: async function () {
      /// checkUserName Validation Setting
      let checkerName = this.getCheckUserName;
      let getBackName;
      this.$validator.extend('checkUserName', {
        getMessage: 'Bu Kullanıcı Adı Kullanımda',
        validate: async function (value, field) {
          await checkerName(value).then(res => {
            getBackName = res
          });
          return !getBackName;
        }
      });

      this.$validator.extend('passwordPolicy', {
        getMessage: 'Şifre en az 1 büyük harf, 1 küçük harf, 1 rakam, 1 özel karakter içermeli ve Türkçe karakter içermemelidir.',
        validate: value => {
          const hasUpperCase = /[A-Z]/.test(value);
          const hasLowerCase = /[a-z]/.test(value);
          const hasDigit = /\d/.test(value);
          const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(value);
          const hasTurkish = /[çğışöüÇĞİŞÖÜ]/.test(value);
          return hasUpperCase && hasLowerCase && hasDigit && hasSpecial && !hasTurkish;
        }
      });

      this.$validator.extend('userNamePolicy', {
        getMessage: 'Kullanıcı adı sadece İngilizce harf ve rakamlardan oluşmalı; boşluk, özel karakter veya Türkçe karakter içermemelidir.',
        validate: value => {
          return /^[a-zA-Z0-9]+$/.test(value);
        }
      });
    }
  }

</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

</style>
